export default class profileOverlay {
  constructor(element) {
    this.element = element;
    this.openButton = this.element.querySelector('.js-open-dialog');
    this.dialog = this.element.querySelector('.js-dialog');
    this.closeButton = this.element.querySelector('.js-dialog-close');
   //  this.overlayBg = this.element.querySelector('.profiles__overlay-bg');

    this.init();
  }

  init() {
    this.addEventListeners();
  }

  addEventListeners() {
    // Event listener to open the dialog
    this.openButton.addEventListener('click', (e) => {
		this.dialog.showModal();
    });

    // Event listener to close the dialog with the close button
    this.closeButton.addEventListener('click', () => {
      this.dialog.close();
    });

	this.dialog.addEventListener('click', ({target}) => {
		if (target.nodeName === 'DIALOG') {
			this.dialog.close();
		}
	})

    // Optional: add event listener for escape key to close the dialog
    this.dialog.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.dialog.close();
      }
    });
  }
}
